import React from "react";
import IconWithArrow from "../../components/IconWithArrow";

export default class About extends React.Component {
  render() {
    return (
      <div className="container text-white py-3 vh-100">
        <div className="row">
          <div className="col-2 align-items-center d-flex">
            <i className="fas fa-info-circle fa-2x" />
          </div>
          <div className="col-10 pt-2">
            <h5>About</h5>
          </div>
          <div className="col-11 ml-auto">
            <IconWithArrow
              label="Privacy Policy"
              link="https://wiki.locatorx.com/privacy-policy/"
              showArrow={true}
              showUnderline="true"
            />
          </div>
          <div className="col-11 ml-auto">
            <IconWithArrow
              label="Terms & Conditions"
              link="https://wiki.locatorx.com/terms-of-use/"
              newWindow={false}
              showArrow={true}
              showUnderline={true}
            />
          </div>
          <div className="col-11 ml-auto">
            <IconWithArrow
              label="LocatorX"
              link="https://www.locatorx.com/"
              newWindow={false}
              showArrow={true}
              showUnderline={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
